import Cookies from 'universal-cookie'
import { CookieDomain } from '../config.js'
let cookieConfig = {path : '/'}
if (process.env.NODE_ENV !== 'development') {
  cookieConfig = {...cookieConfig, ...{secure: true, sameSite: 'none'}}
}
if (CookieDomain !== '') {
  cookieConfig = {...cookieConfig, ...{ domain: CookieDomain }}
}
const cookies = new Cookies();

export default {
  saveCookie (name, value) {
    cookies.set(name, value, cookieConfig)
  },
  getCookie (name) {
    return cookies.get(name)
  },
  removeCookie (name) {
    cookies.remove(name, cookieConfig)
  },
  signOut () {
    cookies.remove('wust', cookieConfig)
  },
  isLogin () {
    return !!cookies.get('wust')
  }
}



// WEBPACK FOOTER //
// ./src/utils/authService.js